// extracted by css-extract-rspack-plugin
export default {"ResourceCard":"E9njS"};